<div class="container">
    <section class="wrapper">
        <header class="header">{{ 'Subscription.title' | translate }}</header>
        <div class="redline"></div>
        <div *ngIf="status === 'Unpaid'" class="status-box">
            <div class="img-container">
                <img src="assets/images/subscriptions/pay.png" />
            </div>
            <div class="status-text">{{ 'Subscription.paying' | translate }}</div>
        </div>
        <div *ngIf="status === 'Paid'" class="status-box">
            <div class="img-container">
                <img src="assets/images/subscriptions/pay-success.png" />
            </div>
            <div class="status-title">{{ 'Subscription.success.title' | translate }}</div>
            <div class="status-text">{{ 'Subscription.success.text' | translate }}</div>
            <app-button class="status-btn" [text]="'Subscription.success.button' | translate"
                (btnClick)="goToService()" />
        </div>
        <div *ngIf="status === 'Failed'" class="status-box">
            <div class="status-title">{{ 'Subscription.failed.title' | translate }}</div>
            <app-button class="status-btn" [text]="'Subscription.failed.button' | translate"
                (btnClick)="goToService()" />
        </div>
    </section>
</div>